__turbopack_context__.v({
  "button": "bTdEda_button",
  "button_web3": "bTdEda_button_web3",
  "checkboxConteiner": "bTdEda_checkboxConteiner",
  "checkboxConteiner_dark": "bTdEda_checkboxConteiner_dark",
  "contact-form__disclaimer": "bTdEda_contact-form__disclaimer",
  "contact-form__disclaimer_dark": "bTdEda_contact-form__disclaimer_dark",
  "contact-form__disclaimer_web3": "bTdEda_contact-form__disclaimer_web3",
  "input": "bTdEda_input",
  "inputGroup": "bTdEda_inputGroup",
  "inputGroup_dark": "bTdEda_inputGroup_dark",
  "inputGroup_web3": "bTdEda_inputGroup_web3",
  "label": "bTdEda_label",
  "namesRow_web3": "bTdEda_namesRow_web3",
  "selectControl": "bTdEda_selectControl",
  "selectGroup": "bTdEda_selectGroup",
  "selectGroup_dark": "bTdEda_selectGroup_dark",
  "selectGroup_web3": "bTdEda_selectGroup_web3",
  "selectLabel": "bTdEda_selectLabel",
  "textAreaGroup": "bTdEda_textAreaGroup",
  "textAreaGroup_dark": "bTdEda_textAreaGroup_dark",
  "textAreaGroup_web3": "bTdEda_textAreaGroup_web3",
});
